import { connect,no_render} from 'core'
import * as selectors from 'selectors';
import { PmInfo } from 'comp/right/pm_info';


const mapToProps = state => {
  const selected = selectors.getSelectedPM()
  const tmp_pm = state.ui.tmp_pm

  if(!selected && !tmp_pm) {
    return no_render
  }

  const title = (tmp_pm && tmp_pm.name) || selected.title;
  const member_id = (tmp_pm && tmp_pm.id) || selected.member_id;
  const member = tmp_pm || selected.members[member_id];


  return {title,member,jumping:state.ui.jump_to_conv}
};


export default connect(PmInfo,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/right/PmInfo.js